/* ============================================================================
   KHP Custom Collection Pages — Behavior (v6)
   v6 adds:
   - Quick View image gallery: thumbnails under the main image, click to swap
     (reads data.images array from pcard-data JSON; falls back to single image)
   v5 fixes:
   - Quick View now populates Shipping + Returns tabs from product metafields
     (data.shipping / data.returns in pcard-data JSON, added in
     product-card-custom.liquid v2)
   - Falls back to default copy in #qvShippingDefault / #qvReturnsDefault
     <template> tags (quick-view-modal.liquid v2) when metafields are blank
   v4 fixes:
   - Mobile dropdown actually filters now (uses data-chip-group-mobile attr)
   - Mobile dropdown shows prefix (e.g. "Collection: Kaleidoscope Kids")
   ============================================================================ */

(function () {
  'use strict';

  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // =========================================================================
  // QUICK VIEW MODAL
  // =========================================================================
  const overlay = $('#qvOverlay');
  if (overlay) {
    const closeBtn   = $('#qvClose');
    const qvImage    = $('#qvImage');
    const qvThumbs   = $('#qvThumbs');
    const qvCategory = $('#qvCategory');
    const qvTitle    = $('#qvTitle');
    const qvPrice    = $('#qvPrice');
    const qvDetails  = $('#qvDetails');
    const qvHow      = $('#qvHow');
    const qvShipping = $('#qvShipping');
    const qvReturns  = $('#qvReturns');
    const qvForm     = $('#qvAddForm');
    const qvVariant  = $('#qvVariantId');
    const qvFullLink = $('#qvFullLink');
    // Force navigation — theme has a global click handler eating anchor clicks
if (qvFullLink) {
  qvFullLink.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const dest = qvFullLink.getAttribute('href');
    if (dest && dest !== '#') window.location.assign(dest);
  });
}

    // Default copy templates (from quick-view-modal.liquid v2).
    // Read once; used when a product's shipping/returns metafields are blank.
    const shipDefaultTpl = $('#qvShippingDefault');
    const retDefaultTpl  = $('#qvReturnsDefault');
    const shipDefault = shipDefaultTpl ? shipDefaultTpl.innerHTML : '';
    const retDefault  = retDefaultTpl  ? retDefaultTpl.innerHTML  : '';
// Pretty-print policy text: each line becomes a paragraph,
// with any "Label:" prefix bolded (matches the rich text look)
function formatPolicy(html) {
  if (!html) return '';
  return html
    .split(/<br\s*\/?>/i)
    .map(line => line.trim())
    .filter(Boolean)
    .map(line => {
      const m = line.match(/^([^:<]{2,40}):(\s*)(.*)$/);
      return m
        ? `<p class="qv-policy-line"><strong>${m[1]}:</strong> ${m[3]}</p>`
        : `<p class="qv-policy-line">${line}</p>`;
    })
    .join('');
}
    function openQuickView(card) {
      const dataEl = card.querySelector('script.pcard-data');
      if (!dataEl) return;
      let data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      // Gallery: use images array if present, else fall back to single image
      const gallery = (Array.isArray(data.images) && data.images.length)
        ? data.images
        : (data.image ? [data.image] : []);
      const altText = (data.title || '').replace(/"/g, '&quot;');

      function setMainImage(src) {
        qvImage.innerHTML = src ? `<img src="${src}" alt="${altText}">` : '';
        if (qvThumbs) {
          $$('.qv-thumb', qvThumbs).forEach(t =>
            t.classList.toggle('active', t.dataset.src === src));
        }
      }

      setMainImage(gallery[0] || '');

      if (qvThumbs) {
        qvThumbs.innerHTML = '';
        if (gallery.length > 1) {
          gallery.forEach((src, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qv-thumb' + (i === 0 ? ' active' : '');
            btn.dataset.src = src;
            btn.setAttribute('aria-label', 'View image ' + (i + 1));
            btn.innerHTML = `<img src="${src}" alt="" loading="lazy">`;
            btn.addEventListener('click', () => setMainImage(src));
            qvThumbs.appendChild(btn);
          });
        }
      }
      qvCategory.textContent = data.category || '';
      qvTitle.textContent    = data.title || '';
      qvPrice.textContent    = data.priceFormatted || formatMoney(data.price || 0);
      qvDetails.innerHTML    = data.description || '<em>No description available.</em>';
      qvHow.innerHTML        = data.howToUse || '<em>How-to-use instructions coming soon.</em>';

      // Shipping / Returns — product metafield if present, else default copy
      if (qvShipping) qvShipping.innerHTML = data.shipping ? formatPolicy(data.shipping) : shipDefault;
      if (qvReturns)  qvReturns.innerHTML  = data.returns  ? formatPolicy(data.returns)  : retDefault;
      qvVariant.value        = data.variantId || '';

      // PDP link (full details, reviews, benefits, ingredients)
      if (qvFullLink) {
        if (data.url) {
          qvFullLink.href = data.url;
          qvFullLink.style.display = '';
        } else {
          qvFullLink.style.display = 'none';
        }
      }

      $$('.qv-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === 'details'));
      $$('.qv-tabpanel').forEach(p => p.classList.toggle('active', p.dataset.tabpanel === 'details'));

      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeQuickView() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-open-quickview]');
      if (trigger) {
        e.preventDefault();
        const card = trigger.closest('.pcard');
        if (card) openQuickView(card);
      }
    });

    closeBtn && closeBtn.addEventListener('click', closeQuickView);
    overlay.addEventListener('click', e => { if (e.target === overlay) closeQuickView(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeQuickView(); });

    $$('.qv-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        $$('.qv-tab').forEach(t => t.classList.toggle('active', t === tab));
        $$('.qv-tabpanel').forEach(p => p.classList.toggle('active', p.dataset.tabpanel === target));
      });
    });

    qvForm && qvForm.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = qvForm.querySelector('button[type=submit]');
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Adding...';
      try {
        const formData = new FormData(qvForm);
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('Add to cart failed');
        btn.innerHTML = '✓ Added to Cart';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = originalText;
          closeQuickView();
        }, 1200);
      } catch (err) {
        btn.innerHTML = 'Error — try again';
        btn.disabled = false;
        setTimeout(() => { btn.innerHTML = originalText; }, 1800);
      }
    });
  }

  // =========================================================================
  // AJAX ADD-TO-CART (card buttons)
  // =========================================================================
  document.addEventListener('submit', async e => {
    const form = e.target.closest('.pcard-form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('.pcard-cta');
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding...';

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!res.ok) throw new Error('Add to cart failed');
      btn.innerHTML = '✓ Added';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }, 1500);
    } catch (err) {
      btn.innerHTML = 'Error — try again';
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }, 1800);
    }
  });

  // =========================================================================
  // CHIP COUNT POPULATOR
  // =========================================================================
  async function populateChipCounts() {
    const allChip = document.querySelector('.cc-chip[data-filter-tag=""]');
    if (!allChip) return;
    const baseUrl = allChip.getAttribute('href');
    if (!baseUrl) return;

    try {
      const res = await fetch(baseUrl + '/products.json?limit=250');
      if (!res.ok) return;
      const data = await res.json();
      const products = data.products || [];

      const normalizeTags = (tags) => {
        if (!tags) return [];
        if (Array.isArray(tags)) return tags.map(t => String(t).trim().toLowerCase());
        return String(tags).split(',').map(t => t.trim().toLowerCase());
      };

      const tagVariants = (tag) => {
        const lc = tag.toLowerCase();
        return Array.from(new Set([
          lc,
          'category:' + lc,
          'style:' + lc,
          'type:' + lc,
          lc.replace(/-/g, ' '),
          lc.replace(/-/g, ''),
        ]));
      };

      document.querySelectorAll('.cc-chip[data-filter-tag=""] .count').forEach(el => {
        el.textContent = products.length;
      });

      const filterChips = document.querySelectorAll('.cc-chip[data-filter-tag]:not([data-filter-tag=""])');
      filterChips.forEach(chip => {
        const tag = (chip.dataset.filterTag || '').toLowerCase();
        if (!tag) return;
        const variants = tagVariants(tag);
        let count = 0;
        for (const p of products) {
          const productTags = normalizeTags(p.tags);
          if (variants.some(v => productTags.includes(v))) count++;
        }
        const countEl = chip.querySelector('.count');
        if (countEl) countEl.textContent = count;
      });
    } catch (err) {
      console.warn('[KHP chips] Chip count fetch failed:', err);
    }
  }
  populateChipCounts();

  // =========================================================================
  // MULTI-GROUP FILTER + SORT SYSTEM
  // =========================================================================
  const chipGroupsContainer = document.querySelector('.cc-browse');
  if (chipGroupsContainer) {

    const tagVariants = (tag) => {
      const lc = tag.toLowerCase();
      return Array.from(new Set([
        lc,
        'category:' + lc,
        'style:' + lc,
        'type:' + lc,
        lc.replace(/-/g, ' '),
        lc.replace(/-/g, ''),
      ]));
    };

    const getCardTags = (card) => {
      const raw = card.dataset.productTags || '';
      return raw.split(',').map(t => t.trim().toLowerCase()).filter(Boolean);
    };

    const parsePrice = (card) => {
      const el = card.querySelector('.pcard-price');
      if (!el) return 0;
      return parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
    };

    const filterState = {
      active: {},
      sort: 'best-selling',
      originalOrder: [],
    };

    function cacheOriginalOrder() {
      const grid = document.querySelector('.cc-grid');
      if (!grid) return;
      filterState.originalOrder = Array.from(grid.querySelectorAll('.pcard'));
    }
    cacheOriginalOrder();

    function applyAllFilters() {
      const allCards = document.querySelectorAll('.cc-grid .pcard');
      const activeKeys = Object.keys(filterState.active).filter(k => filterState.active[k]);

      allCards.forEach(card => {
        if (activeKeys.length === 0) {
          card.classList.remove('is-hidden');
          return;
        }
        const cardTags = getCardTags(card);
        const matchesAll = activeKeys.every(groupId => {
          const tag = filterState.active[groupId];
          const variants = tagVariants(tag);
          return variants.some(v => cardTags.includes(v));
        });
        card.classList.toggle('is-hidden', !matchesAll);
      });

      const visibleCards = document.querySelectorAll('.cc-grid .pcard:not(.is-hidden)');
      const visibleCountEl = document.querySelector('#cc-visible-count');
      const totalCountEl = document.querySelector('#cc-total-count');
      if (visibleCountEl) visibleCountEl.textContent = visibleCards.length;
      if (totalCountEl && activeKeys.length === 0) {
        totalCountEl.textContent = visibleCards.length;
      }
    }

    function applySort() {
      const grid = document.querySelector('.cc-grid');
      if (!grid) return;

      if (filterState.sort === 'best-selling') {
        filterState.originalOrder.forEach(card => {
          if (card.parentNode === grid) grid.appendChild(card);
        });
      } else {
        const cards = Array.from(grid.querySelectorAll('.pcard'));
        cards.sort((a, b) => {
          const priceA = parsePrice(a);
          const priceB = parsePrice(b);
          return filterState.sort === 'price-low' ? priceA - priceB : priceB - priceA;
        });
        cards.forEach(card => grid.appendChild(card));
      }
    }

    async function loadAllRemaining() {
      const btn = document.querySelector('#cc-load-more-btn');
      if (!btn || btn.disabled) return;

      const grid = document.querySelector('.cc-grid');
      const gridWrap = document.querySelector('#cc-grid-wrap') || document.querySelector('.cc-grid-wrap');
      if (gridWrap) gridWrap.classList.add('is-loading');

      let nextUrl = btn.getAttribute('href');
      let safetyCounter = 0;
      while (nextUrl && safetyCounter < 20) {
        safetyCounter++;
        try {
          const res = await fetch(nextUrl);
          if (!res.ok) break;
          const html = await res.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newCards = parsed.querySelectorAll('.cc-grid .pcard');
          newCards.forEach(c => grid.appendChild(c));

          const newLoadMore = parsed.querySelector('#cc-load-more-btn');
          if (newLoadMore && newLoadMore.getAttribute('href')) {
            nextUrl = newLoadMore.getAttribute('href');
          } else {
            btn.textContent = '✓ All Caught Up';
            btn.style.opacity = '0.6';
            btn.disabled = true;
            nextUrl = null;
          }
        } catch (err) {
          break;
        }
      }

      cacheOriginalOrder();

      const visibleCountFoot = document.querySelector('#cc-visible-count-foot');
      if (visibleCountFoot) visibleCountFoot.textContent = grid.children.length;

      if (gridWrap) gridWrap.classList.remove('is-loading');
    }

    function scrollToGridOnMobile() {
      if (window.innerWidth >= 700) return;
      const grid = document.querySelector('#cc-grid-wrap') || document.querySelector('.cc-grid-wrap');
      if (!grid) return;
      const rect = grid.getBoundingClientRect();
      const scrollY = window.scrollY + rect.top - 16;
      window.scrollTo({ top: scrollY, behavior: 'smooth' });
    }

    function syncActiveUI() {
      // Desktop chip groups
      document.querySelectorAll('[data-chip-group]').forEach(groupContainer => {
        const groupId = groupContainer.dataset.chipGroup;
        const activeTag = filterState.active[groupId] || '';
        groupContainer.querySelectorAll('.cc-chip').forEach(chip => {
          const chipTag = chip.dataset.filterTag || '';
          chip.classList.toggle('active', chipTag === activeTag);
        });
      });

      // Mobile dropdown wrappers (separate from desktop chip groups)
      document.querySelectorAll('[data-chip-group-mobile]').forEach(wrapper => {
        const groupId = wrapper.dataset.chipGroupMobile;
        const activeTag = filterState.active[groupId] || '';
        const select = wrapper.querySelector('.cc-filter-select');
        if (!select) return;

        select.value = activeTag;

        // Update label with prefix (e.g. "Collection: Kaleidoscope Kids")
        const prefix = wrapper.dataset.mobilePrefix || '';
        if (prefix) {
          Array.from(select.options).forEach(opt => {
            // Cache the original label once (without prefix)
            if (!opt.dataset.baseLabel) {
              opt.dataset.baseLabel = opt.textContent.trim();
            }
            opt.textContent = prefix + ': ' + opt.dataset.baseLabel;
          });
        }

        wrapper.classList.toggle('has-value', !!activeTag);
      });

      // Show/hide Clear filters
      const hasAnyActive = Object.values(filterState.active).some(v => v);
      const clearBtn = document.querySelector('#cc-clear-filters');
      if (clearBtn) clearBtn.hidden = !hasAnyActive;
    }

    async function updateAfterStateChange(opts) {
      opts = opts || {};
      const hasAnyActive = Object.values(filterState.active).some(v => v);
      if (hasAnyActive) await loadAllRemaining();
      applyAllFilters();
      applySort();
      syncActiveUI();
      if (opts.scrollMobile) scrollToGridOnMobile();
    }

    // DESKTOP CHIP CLICK HANDLER
    chipGroupsContainer.addEventListener('click', async e => {
      const chip = e.target.closest('.cc-chip');
      if (!chip) return;

      if (chip.hasAttribute('data-clear-filters')) {
        e.preventDefault();
        Object.keys(filterState.active).forEach(k => filterState.active[k] = '');
        await updateAfterStateChange({ scrollMobile: true });
        return;
      }

      const groupContainer = chip.closest('[data-chip-group]');
      if (!groupContainer) return;
      e.preventDefault();

      const groupId = groupContainer.dataset.chipGroup;
      const newTag = chip.dataset.filterTag || '';

      filterState.active[groupId] = newTag;
      await updateAfterStateChange({ scrollMobile: true });
    });

    // MOBILE DROPDOWN CHANGE HANDLER — uses data-chip-group-mobile
    document.querySelectorAll('.cc-filter-select').forEach(select => {
      select.addEventListener('change', async () => {
        const wrapper = select.closest('[data-chip-group-mobile]');
        const groupId = wrapper ? wrapper.dataset.chipGroupMobile : null;
        if (!groupId) {
          console.warn('[KHP filter] Mobile select has no group id');
          return;
        }
        filterState.active[groupId] = select.value || '';
        await updateAfterStateChange({ scrollMobile: true });
      });
    });

    // SORT DROPDOWN CHANGE HANDLER
    document.querySelectorAll('.cc-sort-select').forEach(select => {
      select.addEventListener('change', async () => {
        filterState.sort = select.value;
        document.querySelectorAll('.cc-sort-select').forEach(s => {
          if (s !== select) s.value = filterState.sort;
        });
        await loadAllRemaining();
        applyAllFilters();
        applySort();
        scrollToGridOnMobile();
      });
    });

    window.addEventListener('popstate', () => {
      Object.keys(filterState.active).forEach(k => filterState.active[k] = '');
      filterState.sort = 'best-selling';
      applyAllFilters();
      applySort();
      syncActiveUI();
    });

    // Initialize active state from HTML
    document.querySelectorAll('[data-chip-group]').forEach(groupContainer => {
      const groupId = groupContainer.dataset.chipGroup;
      const activeChip = groupContainer.querySelector('.cc-chip.active');
      if (activeChip && activeChip.dataset.filterTag) {
        filterState.active[groupId] = activeChip.dataset.filterTag;
      } else {
        filterState.active[groupId] = '';
      }
    });
    // Also register any mobile-only groups (in case mobile dropdowns exist for groups not represented in desktop)
    document.querySelectorAll('[data-chip-group-mobile]').forEach(wrapper => {
      const groupId = wrapper.dataset.chipGroupMobile;
      if (!(groupId in filterState.active)) {
        filterState.active[groupId] = '';
      }
    });
    syncActiveUI();
  }

  // =========================================================================
  // AJAX LOAD MORE
  // =========================================================================
  document.addEventListener('click', async e => {
    const btn = e.target.closest('#cc-load-more-btn');
    if (!btn) return;
    e.preventDefault();

    const nextUrl = btn.getAttribute('href');
    if (!nextUrl || btn.disabled) return;

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'Loading…';

    try {
      const res = await fetch(nextUrl);
      if (!res.ok) throw new Error('Load more fetch failed');
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      const grid = $('.cc-grid');
      const newCards = parsed.querySelectorAll('.cc-grid .pcard');
      newCards.forEach(c => grid.appendChild(c));

      const newLoadMore = parsed.querySelector('#cc-load-more-btn');
      if (newLoadMore && newLoadMore.getAttribute('href')) {
        btn.setAttribute('href', newLoadMore.getAttribute('href'));
        btn.disabled = false;
        btn.textContent = original;
      } else {
        btn.textContent = '✓ All Caught Up';
        btn.style.opacity = '0.6';
      }

      const visibleCount = $('#cc-visible-count');
      if (visibleCount) visibleCount.textContent = grid.children.length;
      const visibleCountFoot = $('#cc-visible-count-foot');
      if (visibleCountFoot) visibleCountFoot.textContent = grid.children.length;
    } catch (err) {
      console.error('Load more failed:', err);
      btn.disabled = false;
      btn.textContent = original;
    }
  });
})();